import React, { Component } from 'react';
import { Button, Input, Select, Tooltip } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import API_URL from '../../../common/url';
import { JdeApplyStatus } from '../ApplyJdeCode/constants';

const { Option } = Select;

// 共享常量中已包含 助理审批(ASSISTANT_APPROVAL)/助理审批不通过(ASSISTANT_APPROVAL_DISAGREE)
// UNAPPLIED: 未申请,即还未生成JDE建号申请 后端按 jde_apply_id is null 过滤
const CrmJdeApplyStatus = {
    UNAPPLIED: '未申请',
    ...JdeApplyStatus,
};

const JdeApplyStatusOption = Object.keys(CrmJdeApplyStatus).map(d => (
    <Option key={String(d)} text={CrmJdeApplyStatus[d]}>
        <Tooltip placement="right" title={CrmJdeApplyStatus[d]}>
            <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{CrmJdeApplyStatus[d]}</span>
        </Tooltip>
    </Option>
));

class Filter extends Component {
    state = {
        reRender: true,
        searchParams: {},
    }

    componentDidMount() {
        this.search();
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    reset = () => {
        this.setState({
            reRender: false,
            searchParams: {},
        }, () => {
            this.setState({ reRender: true }, () => {
                this.search();
            });
        })
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    export = () => {
        this.props.export();
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    // BA 精确搜索：按选择的用户ID(userId)查询
    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    render() {
        const { searchParams, reRender } = this.state;
        const {
            businessOpportunityNum,
            customerProjectCode,
            jdeApplyCode,
            jdeApplyStatus,
        } = searchParams;
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar bar2">
                    <div className="search-item">
                        <label className="ui-label">业务机会编号</label>
                        <Input placeholder="请输入" value={businessOpportunityNum} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'businessOpportunityNum')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户项目号</label>
                        <Input placeholder="请输入" value={customerProjectCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'customerProjectCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE建号申请单号</label>
                        <Input placeholder="请输入" value={jdeApplyCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'jdeApplyCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">BA</label>
                        {
                            reRender &&
                            <HighSearchInput
                                name="user"
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'baUserId', 'userOptions')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE建号申请状态</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 160}}
                            value={jdeApplyStatus}
                            optionLabelProp="text"
                            onChange={value => this.handleSelectChange(value, 'jdeApplyStatus')}
                        >
                            { JdeApplyStatusOption }
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                    </div>
                </div>
            </div>
        )
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/contractManagement/crmContractRecord/Filter.js